<script lang="ts" setup>
    import '../../../css/choice.css';  
    import {onMounted,computed,ref,watch,reactive} from 'vue';  
    import Icon from "../../components/Icon.vue";   
    import TextInput from '../../components/TextInput.vue';
    import SearchProcedureCode from '../../components/Search/SearchProcedureCode.vue';
    import SearchDiagnosisCode from '../../components/Search/SearchDiagnosisCode.vue';
    import {valdiationRule,validationRuleType,validationRuleFlag} from '../../lib/Models/CodeValidationCopyModel';
    import {Alignment} from '../../Enums/ChoiceEnums';
    import {IconTypes,DisplayStyle} from "../../Enums/UiEnums"; 
    import {initPinia} from '../../lib/PiniaMgr';
    import {useCodeValidationCopyStore} from '../../lib/Stores/CodeValidationCopyStore';
    import {ICodeSearchItem} from '../../lib/ChoiceApi';

    const codeValidationCopyStore = useCodeValidationCopyStore(initPinia()); 
    const formData = reactive <
    {   
        ruleValue: string,
        componentKey: number
    }>({
        ruleValue: "",
        componentKey: 0
    });
    const props = withDefaults(defineProps<{ 
        validationID: number,
    }>(),
    {
        validationID: 0
    });
    onMounted(async () => {  
        if (props.validationID > 0) { 
        }
    }); 
    const editRuleFlag = computed<validationRuleFlag>(()=> {
        if (props.validationID == valdiationRule.DxRequired || 
            props.validationID == valdiationRule.ModRequired ||
            props.validationID == valdiationRule.PcRequired ||
            props.validationID == valdiationRule.DxRequired) {
            return validationRuleFlag.required;
        }
        return validationRuleFlag.restricted;
    });
    const editRuleType = computed<validationRuleType>(()=> {
        if (props.validationID == valdiationRule.DxRequired || props.validationID == valdiationRule.DxRestricted) {
            return validationRuleType.diagnosisCode;
        }
        if (props.validationID == valdiationRule.ModRequired || props.validationID == valdiationRule.ModRestricted) {
            return validationRuleType.modifer;
        }
        if (props.validationID == valdiationRule.PcRequired || props.validationID == valdiationRule.PcRestricted) {
            return validationRuleType.procedureCode;
        }
        return validationRuleType.primaryDX;
    }); 
    const searchTitle = computed<string>(()=> {
        if (props.validationID == valdiationRule.DxRequired || props.validationID == valdiationRule.DxRestricted) {
            return "Diagnosis Code";
        }
        if (props.validationID == valdiationRule.ModRequired || props.validationID == valdiationRule.ModRestricted) {
            return "Modifier";
        }
        if (props.validationID == valdiationRule.PcRequired || props.validationID == valdiationRule.PcRestricted) {
            return "Procedure Code";
        }
        return "Primary Diagnosis Code"
    });
    function deleteValue(ruleValue : string) : void {
        if (ruleValue == "") {
            return;
        }
        codeValidationCopyStore.deleteValidateValue(props.validationID,editRuleType.value,editRuleFlag.value,ruleValue);
    }
    function onChangeCode(codeSearch: ICodeSearchItem | void) : void { 
        if (!codeSearch) {
            return;
        } 
        if (!codeSearch.code) {
            return;
        }
        codeValidationCopyStore.addValidationValue(props.validationID,editRuleType.value,editRuleFlag.value,codeSearch.code);
        formData.ruleValue = "";
    }
    function onValueChange() : void {
        if (!formData.ruleValue) {
            return;
        }
        codeValidationCopyStore.addValidationValue(props.validationID,editRuleType.value,editRuleFlag.value,formData.ruleValue);
        formData.ruleValue = "";
    }
</script> 

<style scoped> 
    .data-cell {
      FONT-SIZE: .75rem;
      font-family: Arial, sans-serif, Helvetica;
      padding: 2px 2px 2px 2px;
      cursor: default;
      vertical-align: top;
    }
</style>
<template>
    <div v-if="editRuleType == validationRuleType.modifer" class="row">
        <div class="col label-isalus-small">
            <span>{{searchTitle}}</span>
            <div style="width: 5rem;">
                <TextInput 
                    v-model:textValue="formData.ruleValue"
                    :placeholder="searchTitle" 
                    :required="false"
                    :cssFramework="'vanilla'"  
                    :maxLength="2"
                    :alignment="Alignment.center"
                    :title="searchTitle"
                    @change:text-value="onValueChange()" >
                </TextInput> 
            </div>
        </div>
    </div>
    <div v-if="editRuleType == validationRuleType.procedureCode" class="row"> 
        <div class="col label-isalus-small">
            <SearchProcedureCode 
                v-model:defaultSearchText="formData.ruleValue" 
                :key="formData.componentKey" 
                :label="searchTitle" 
                :enable-auto-search="true" 
                :show-clear-search="true" 
                placeholder="Search Procedure Code" 
                @onChange="onChangeCode" />
        </div>
    </div>
    <div v-if="editRuleType == validationRuleType.diagnosisCode || editRuleType == validationRuleType.primaryDX" class="row"> 
        <div class="col label-isalus-small">
            <SearchDiagnosisCode 
                v-model:defaultSearchText="formData.ruleValue" 
                :key="formData.componentKey" 
                :label="searchTitle" 
                :enable-auto-search="true" 
                :show-clear-search="true" 
                placeholder="Search Diagnosis Code" 
                @onChange="onChangeCode" />
        </div>
    </div>
    <div class="row pt-3">
        <div class="col">
            <table style="table-layout: fixed; width: 10rem;">
                <colgroup>
                    <col style="width: 2rem;"/>
                    <col style="width: 6rem;"/>
                    <col style="width: 2rem;"/>
                </colgroup>
                <tr class="label-isalus-small" v-for="(item,index) in codeValidationCopyStore.codeValidationResults.filter(item => item.ruleId == props.validationID && item.ruleValue != '')" >
                    <td>{{index + 1}}.</td>
                    <td>{{item.ruleValue}}</td>
                    <td>
                        <Icon 
                            :icon="IconTypes.Delete" 
                            :displayStyle="DisplayStyle.Danger" 
                            :class="'label-isalus-small text-isalus-primary'"
                            :title="'Delete validation value'"
                            @click="() => deleteValue(item.ruleValue)"/>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>
